export enum EnumTypeFigureProvider {
  MANAGER = 'MANAGER',
  OWNER = 'OWNER'
}

export const TYPE_FIGURE_PROVIDER = {
  MANAGER: 'MANAGER',
  OWNER: 'OWNER'
} as const

export const NAME_TYPE_FIGURE_PROVIDER = {
  MANAGER: 'Gestor',
  OWNER: 'Propietario'
}

export const CATALOG_TYPE_FIGURE_PROVIDER = [
  {
    value: TYPE_FIGURE_PROVIDER.MANAGER,
    label: NAME_TYPE_FIGURE_PROVIDER.MANAGER
  },
  {
    value: TYPE_FIGURE_PROVIDER.OWNER,
    label: NAME_TYPE_FIGURE_PROVIDER.OWNER
  }
]
